import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { PackageSearch, ArrowRight } from "lucide-react";
import { PuntoEnvioMark } from "../site/PuntoEnvioMark";
import { FadeUp, MaskLines } from "../site/Motion";

export const PuntoEnvioTeaser = () => {
  const ref = useRef(null);
  const nav = useNavigate();
  const [code, setCode] = useState("");
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const x = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section ref={ref} data-testid="home-puntoenvio" className="grain relative overflow-hidden bg-[var(--ink)] py-20 text-white md:py-32">
      <div className="mx-auto grid max-w-[1400px] items-center gap-14 px-5 md:px-10 lg:grid-cols-2">
        <div>
          <PuntoEnvioMark size="text-4xl md:text-5xl" />
          <h2 className="mt-8 font-display text-4xl md:text-6xl"><MaskLines inView lines={["Entregas rápidas", <span key="b" className="text-[var(--lime)]">y fáciles de seguir.</span>]} /></h2>
          <p className="mt-6 max-w-md text-white/80">Encomiendas y cargas que viajan con nosotros. Cotizá, despachá en agencia y seguí cada etapa con tu código.</p>
          <FadeUp>
            <form onSubmit={(e) => { e.preventDefault(); nav(`/puntoenvio?code=${encodeURIComponent(code)}`); }} className="mt-10 flex max-w-lg flex-col gap-3 sm:flex-row">
              <input data-testid="teaser-track-input" value={code} onChange={(e) => setCode(e.target.value)} required placeholder="Número de orden PuntoEnvío" className="h-14 w-full rounded-2xl border border-white/15 bg-white/5 px-5 font-mono text-white placeholder:text-white/50 focus:border-[var(--lime)] focus:outline-none sm:flex-1" />
              <button data-testid="teaser-track-button" className="flex h-14 items-center justify-center gap-2 rounded-2xl bg-[var(--lime)] px-6 font-bold text-[var(--ink)] transition-transform duration-300 hover:-translate-y-0.5">
                <PackageSearch className="h-5 w-5" /> Rastrear
              </button>
            </form>
          </FadeUp>
          <button onClick={() => nav("/puntoenvio")} data-testid="teaser-quote-link" className="group mt-6 inline-flex items-center gap-2 font-semibold text-[var(--lime)]">
            Cotizar una encomienda <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </button>
        </div>
        <FadeUp>
          <div className="relative aspect-[4/3] overflow-hidden rounded-[28px]">
            <motion.img style={{ x, scale: 1.25 }} src="/brand/bus.jpg" alt="Lateral del ómnibus con gráfica PuntoEnvío" className="absolute inset-0 h-full w-full object-cover object-[28%_72%]" />
            <div className="absolute inset-0 bg-gradient-to-tr from-black/60 via-transparent to-transparent" />
            <span className="absolute bottom-5 left-5 rounded-full bg-black/60 px-4 py-2 font-mono text-xs tracking-widest text-[var(--lime)] backdrop-blur-md">ENCOMIENDAS Y CARGAS</span>
          </div>
        </FadeUp>
      </div>
    </section>
  );
};
